/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

document.addEventListener('DOMContentLoaded', () => {
  // COllection FIlter 
  document.addEventListener('change', (event) => {
    const input = event.target;

    if (!input.matches('[data-input-sort]')) return;

    const sortBar = input.closest('.collection__sort-bar');
    if (!sortBar) return;

    const pill = sortBar.querySelector('.collection__sort-pill');
    const label = sortBar.querySelector(`label[for="${input.id}"]`);

    if (pill && label) {
      // Replace only the text, keep the icon
      const icon = pill.querySelector('svg');
      pill.textContent = label.textContent.trim();

      if (icon) {
        pill.appendChild(icon);
      }
    }
  });


  // COllection TAB
  document.querySelectorAll('.why-choose-us').forEach((section) => {
    const tabs = section.querySelectorAll('[data-tab-button]');
    const panels = section.querySelectorAll('[data-tab-panel]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
          const index = tab.dataset.tabIndex;

          tabs.forEach(t => t.classList.remove('is-active'));
          panels.forEach(p => p.classList.remove('is-active'));

          tab.classList.add('is-active');
          section.querySelector(`[data-tab-panel][data-tab-index="${index}"]`)
          .classList.add('is-active');
      });
    });
  });


   document.querySelectorAll('[data-swiper]').forEach((slider) => {
      if (slider.swiper) return;

      const slideCount = slider.querySelectorAll('.swiper-slide').length;
      const desktopSlidesPerView = 9.2;

      const isDesktop = window.innerWidth >= 1024;
      const shouldCenter = isDesktop && slideCount < Math.ceil(desktopSlidesPerView);

      if (shouldCenter) {
        slider.classList.add('swiper--centered');
        slider.classList.add('swiper--no-nav');
      }

      slider.swiper = new Swiper(slider, {
        slidesPerView: desktopSlidesPerView,
        spaceBetween: 24,
        grabCursor: true,
        watchOverflow: true,

        centeredSlides: shouldCenter,
        centeredSlidesBounds: shouldCenter,

        navigation: shouldCenter
          ? false
          : {
              nextEl: '.ctm_next_aero',
              prevEl: '.ctm_prev_aero',
            },

        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true,
        },
        mousewheel: { 
          forceToAxis: true, 
        },
        scrollbar: {
          el: slider.querySelector('.swiper-scrollbar'),
          draggable: true,
          hide: false,
        },

        breakpoints: {
          1024: {
            slidesPerView: 9.2,
            spaceBetween: 24,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
          768: {
            slidesPerView: 5.3,
            spaceBetween: 24,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
          },
          575: {
            slidesPerView: 4.3,
            spaceBetween: 16,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
          },
          375: {
            slidesPerView: 3.3,
            spaceBetween: 14,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
          },
          0: {
            slidesPerView: 3.3,
            spaceBetween: 16,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
          },
        },
      });
    });

      document.querySelectorAll('[data-awards-marquee]').forEach((slider) => {
          if (slider.swiper) return;

              slider.swiper = new Swiper(slider, {
              loop: true,
              allowTouchMove: false, 
              speed: 8000,    
              autoplay: {
                  delay:0,
                  disableOnInteraction: false,
              },
              breakpoints: {
                  1024: {
                      slidesPerView: 4,
                      spaceBetween: 30
                  },
                  768: {
                      slidesPerView: 4,
                      spaceBetween: 30
                  },
                  575: {
                      slidesPerView: "auto",
                      spaceBetween: 10
                  },
                  320: {
                      slidesPerView: "auto",
                      spaceBetween: 10
                  },
                  0: {
                      slidesPerView: "auto",
                      spaceBetween: 10
                  },
              }
          });
      });


       
      new Swiper('.video-highlights', {
        slidesPerView: 'auto',
        spaceBetween: 18,
        grabCursor: true,
        touchStartPreventDefault:false,
        passiveListeners:false,
        simulateTouch:true,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        freeMode: true,
        watchSlidesProgress: true,

        /* 👉 MOUSEWHEEL SUPPORT */
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: true
        },

        breakpoints: {
          0: {
            slidesPerView: 'auto'
          },
          768: {
            slidesPerView: 'auto'
          },
          1024: {
            slidesPerView: 'auto'
          }
        }
      })



});
 
